import { FC } from 'react';
import { FlexGridContainer, FlexGridContainerProps } from './FlexGridContainer';

/**
 * A collection of predefined `FlexGridContainers` that specify d
 */
export const TemplateFlexGridContainer = {
  /**
   * The top level grid container inside a briefing step
   *
   * Should contain the heading and a body
   */
  BriefingStep: ((props: FlexGridContainerProps) =>
    FlexGridContainer({
      xsSpaceY: 8,
      mdSpaceY: 7,
      xxlSpaceY: 8,
      xsDirection: 'col',
      ...props,
    })) as FC<FlexGridContainerProps>,
  /**
   * A container that houses the body of a given briefing step.
   *
   * The body can consist of multiple sections. A section can
   * either be a single node or multiple nodes wrapped in a
   * BriefingStepSection.
   */
  BriefingStepBody: ((props: FlexGridContainerProps) =>
    FlexGridContainer({
      spaceY: props.spaceY || 6,
      mdSpaceY: props.mdSpaceY || 8,
      xxlSpaceY: props.xxlSpaceY || 9,
      xsDirection: props.xsDirection || 'col',
      ...props,
    })) as FC<FlexGridContainerProps>,
  /**
   * A container housing a briefing step section constisting of multiple components.
   *
   * Can be nested when for creating subsections in more complex view hierarchies
   * such as side by side layouts.
   */
  BriefingStepSection: ((props: FlexGridContainerProps) =>
    FlexGridContainer({
      spaceY: 6,
      // ensures that multiple sections in a horizontal grid preseted in a grid align
      xsJustify: 'between',
      xsDirection: 'col',
      fullWidth: true,
      ...props,
    })) as FC<FlexGridContainerProps>,
};
